<div class="toast-box">
  <img *ngIf="isSuccess" src="../../../assets/images/success_onToast.svg" alt="success" />

  <img *ngIf="!isSuccess" src="../../../assets/images/warning.svg" alt="warning" />
  <p>
    {{ message }}
  </p>
</div>